<template>
    <div class="model-wrap game">
        <div class="info-title">
            <span class="icon icon-info-title"></span>
            <div class="text">
                <span><tv k="g1"/></span>
                <span class="sub-text"><tv k="g2"/></span>
            </div>
            <span class="status ok"><tv k="g3"/></span>
        </div>
        <div class="model-line-bg"></div>
        <div class="model-content">
            <div class="game-view-wrap">
                <div class="item">
                    <div class="pic">
                        <iv k="pic3"/>
                    </div>
                    <div class="name"><tv k="g4"/></div>
                </div>
                <div class="item">
                    <div class="pic">
                        <iv k="pic4"/>
                    </div>
                    <div class="name"><tv k="g5"/></div>
                </div>
                <div class="item">
                    <div class="pic">
                        <iv k="pic5"/>
                    </div>
                    <div class="name"><tv k="g6"/></div>
                </div>
                <div class="item">
                    <div class="pic">
                        <iv k="pic6"/>
                    </div>
                    <div class="name"><tv k="g7"/></div>
                </div>
            </div>
            <div class="ctl-wrap">
                <button class="btn btn-red"><tv k="gb1"/></button>
                <button class="btn btn-blue"><tv k="gb2"/></button>
                <button class="btn btn-orange"><tv k="gb3"/></button>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "PlayerModel",
        components: {
        },
        data(){
            return {
                p1: 30
            }
        }
    }
</script>

<style lang="less">
    .game {
        .model-content {
            display: flex;
            flex-direction: column;

            .game-view-wrap{
                display: flex;
                flex-wrap: wrap;
                padding: 10px;
                @marginWidth: 10px;

                .item{
                    width: calc(50% - (@marginWidth / 2));

                    &:nth-child(even){
                        margin-left: @marginWidth;
                    }

                    .pic {
                        border: 1px solid #32c5ff;
                        height: 95px;

                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .name {
                        font-size: 18px;
                        letter-spacing: 0px;
                        color: #32c5ff;
                        text-align: center;
                        padding: 10px 0;
                    }
                }
            }

            .ctl-wrap{
                display: flex;
                flex-grow: 1;
                align-items: center;
                justify-content: space-around;

                .btn{
                    min-width: 83px;
                }
            }
        }
    }

</style>
